<template>
    <div
        class="c-content-editable"
        v-bind:class="[sizeClass, modeClass, truncateClass, hoverClass]"
    >
        <div v-if="disabled">
            <div class="c-content-editable__content">
                {{ formValidate.buffer }}
            </div>
        </div>
        <template v-else>
            <div
                v-if="!editing"
                class="c-content-editable__edit-off"
                @click="onSingleClick"
                @dblclick="open"
            >
                <!-- CLAY ADDED SOME CLASSES HERE TO PRESERVE LINE BREAKS -->
                <div
                    v-if="formValidate.buffer"
                    class="c-content-editable__content"
                >
                    {{ formValidate.buffer }}
                </div>
                <div
                    v-else-if="placeholder"
                    class="c-content-editable__content-placeholder"
                >
                    {{ placeholder }}
                </div>
                <div
                    v-if="mode != 'simple'"
                    @click.stop="editing = true"
                    class="c-content-editable__edit"
                >
                    <span
                        v-if="mode == 'links'"
                        class="c-content-editable__link"
                        >Edit</span
                    >
                    <span v-else class="c-content-editable__icon">
                        <Icon custom="icon icon-pencil-2"></Icon>
                    </span>
                </div>
            </div>
            <div class="c-content-editable__edit-on" v-else>
                <div class="c-content-editable__content">
                    <Form
                        ref="formValidate"
                        :model="formValidate"
                        :rules="ruleValidate"
                    >
                        <FormItem prop="buffer">
                            <Input
                                ref="content"
                                v-focus
                                v-model="formValidate.buffer"
                                @on-blur="onBlur"
                                @on-enter="handleSubmit"
                                @on-keypress="handleKeypress"
                                @on-keyup.esc="handleCancel"
                                :size="inputSize"
                                :class="'merged-button'"
                                :type="type"
                                :autosize="autosize"
                            >
                                <div
                                    v-if="mode != 'simple'"
                                    slot="append"
                                    @click.prevent="handleSubmit"
                                >
                                    <Button
                                        v-if="mode == 'links'"
                                        slot="append"
                                        type="text"
                                        >Save</Button
                                    >
                                    <Button
                                        v-else
                                        slot="append"
                                        custom-icon="icon icon-keyboard-arrow-return-1"
                                        type="text"
                                        class="text-secondary"
                                    />
                                </div>
                            </Input>
                        </FormItem>
                    </Form>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import focus from "@/js/directives/focus-input";

export default {
    props: {
        value: String,
        rules: Array,
        placeholder: String,
        size: {
            type: String,
            default: "medium", // [tiny|small|base|medium|large|xl|xxl]
        },
        mode: {
            type: String,
            default: "simple", // [simple|icons|links]
        },
        truncate: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        hover: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: "text",
        },
        autosize: {
            type: Object,
            default: () => {
                return { minRows: 2 };
            },
        },
        requireDoubleClick: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            originalValue: this.value,
            formValidate: {
                buffer: this.value,
            },
            ruleValidate: {
                buffer: this.rules,
            },
            buffer: this.value,
            editing: false,
        };
    },
    computed: {
        sizeClass: function() {
            return this.size ? "ce-" + this.size : "";
        },
        modeClass: function() {
            return this.mode ? "ce-" + this.mode : "";
        },
        truncateClass: function() {
            return this.truncate ? "ce-truncate" : "";
        },
        hoverClass: function() {
            return this.hover ? "ce-hover" : "";
        },
        inputSize: function() {
            return this.size == "small" ? "small" : "default";
        },
    },
    methods: {
        open() {
            this.editing = true;
        },
        close() {
            this.editing = false;
        },
        onBlur(e) {
            // If they hit tab
            if (this.type != "textarea") {
                e.preventDefault();
                this.handleSubmit();
                return true;
            }

            // close on blur only enabled if no save button (ie. in simple mode)
            if (this.mode == "simple") {
                this.close();
            }
        },
        onSingleClick() {
            if (!this.requireDoubleClick) {
                this.open();
            }
        },
        handleKeypress(e) {
            if (this.type != "textarea" && e.keyCode === 13) {
                e.preventDefault();
                this.handleSubmit();
                return true;
            }

            if (this.type == "textarea" && e.keyCode === 13 && !e.shiftKey) {
                e.preventDefault();
                this.handleSubmit();
                return true;
            }
        },
        async handleSubmit() {
            // new "original" value to revert to on future cancels
            this.originalValue = this.formValidate.buffer;
            let isValid = await this.$refs.formValidate.validate();
            if (isValid) {
                this.$emit("update:value", this.formValidate.buffer);
                this.$emit("submit");
            }
            this.close();
        },
        handleCancel() {
            // revert to original value on cancel (esc key hit)
            this.formValidate.buffer = this.originalValue;
            this.$emit("cancel");
            this.close();
        },
    },
    directives: {
        focus: focus,
    },
};
</script>
